import styles from './styles.module.css';
import BannerCajaGrande from '@/widgets/Banner/Templates/BannerCajaGrande';

const PISO2NOTASBanner = (props) => {
console.log(props);
    return (
          
        <div className={`${styles["Piso2Notas-parent"]}`}>
            <div className={`${styles['primer-bloque']}`}>
                <div className={` ${styles["grid-item"]}`}>{props.renderContainerWidgetCallback(1, "NotaContainerGrilla")}</div>
                <div className={` ${styles["grid-item"]}`}>{props.renderContainerWidgetCallback(2, "NotaContainerGrilla")}</div>
                <div className={` ${styles["grid-item"]}`}>{props.renderContainerWidgetCallback(3, "NotaContainerGrilla")}</div>
                <div className={` ${styles["grid-item"]}`}>{props.renderContainerWidgetCallback(4, "NotaContainerGrilla2")}</div>
                <div className={` ${styles["grid-item"]}`}>{props.renderContainerWidgetCallback(5, "NotaContainerGrilla2")}</div>
                <div className={` ${styles["grid-item"]}`}>{props.renderContainerWidgetCallback(6, "NotaContainerGrilla2")}</div>
            </div>
            <div className={`${styles['segundo-bloque']}`}>
                <BannerCajaGrande bannerId='caja2'/>
            </div>                
        </div>
        
    )
}

export default PISO2NOTASBanner;
